import { Checkbox } from '@mui/material'
import { snakeCaseToSpaces } from 'Utils/formatters'
import { Priorities } from 'Components/SharedComponents/Surveys/types'
import {
  RecommendedGoal,
  RecommendedGoalsContainer,
  Title,
  CheckboxContainer,
} from './RecommendedGoals.styled'
import {
  TemplateLibraryMap,
  HandleToggleOrCreateTemplateGoal,
} from '../../types'
import { Tag } from '../RecommendedResources/RecommendedResources.styled'

type RecommendedGoalsProps = {
  onSelectTemplateGoals: HandleToggleOrCreateTemplateGoal
  priorities: Priorities
  templateGoalsToCreate: number[]
  templateLibraryMap: TemplateLibraryMap
}

export const RecommendedGoals = ({
  onSelectTemplateGoals,
  priorities,
  templateGoalsToCreate,
  templateLibraryMap,
}: RecommendedGoalsProps) => {
  const { firstPriority, secondPriority, thirdPriority } = priorities

  const userGoals = [
    ...firstPriority.selectedGoals,
    ...secondPriority.selectedGoals,
    ...thirdPriority.selectedGoals,
  ]

  return (
    <RecommendedGoalsContainer>
      {userGoals.map((userGoal) => {
        const template = templateLibraryMap[userGoal.templateLibraryId]
        if (!template) return null
        return (
          <RecommendedGoal key={userGoal.label}>
            <Tag>
              {snakeCaseToSpaces(userGoal.category)} - {userGoal.label}
            </Tag>
            <CheckboxContainer>
              <Checkbox
                onChange={() =>
                  onSelectTemplateGoals('toggle', template.templateLibraryId)
                }
                checked={templateGoalsToCreate.includes(
                  template.templateLibraryId
                )}
              />
            </CheckboxContainer>
            <Title>{template.title}</Title>
          </RecommendedGoal>
        )
      })}
    </RecommendedGoalsContainer>
  )
}
